// extracted by mini-css-extract-plugin
export default {"Modal":"signup_Modal__UNNh0","rounded":"signup_rounded__ugucn","closeButton":"signup_closeButton__4IaJZ"};